import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgTwitter(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M23.0531 5H26.7853L18.6316 14.319L28.2238 27H20.7132L14.8306 19.309L8.09968 27H4.36527L13.0864 17.0323L3.88464 5H11.5859L16.9032 12.0298L23.0531 5ZM21.7433 24.7662H23.8113L10.4622 7.11651H8.24296L21.7433 24.7662Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTwitter);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
